import remove from 'lodash/remove';
import { initialRootState } from '../initialRootState';
import { EBlacklistActionType, TBlacklistAction } from './actions';

export interface IBlacklistState {
  list: string[];
}

// TODO: refactor with Immer
export const blacklistReducer = (
  currentState: IBlacklistState = initialRootState.blacklist,
  action: TBlacklistAction
): IBlacklistState => {
  switch (action.type) {
    case EBlacklistActionType.GET_SUCCESS:
      return {
        ...currentState,
        list: action.payload.result.data,
      };
    case EBlacklistActionType.DELETE_SUCCESS:
      const list = [...currentState.list];

      remove(list, (id: string) => id === action.payload.receiverId);

      return {
        ...currentState,
        list,
      };
    case EBlacklistActionType.POST_SUCCESS:
      return {
        ...currentState,
        list: currentState.list.concat(action.payload.receiverId),
      };
    default:
      return currentState;
  }
};
